---
**Observação:** algumas vendas podem ser atribuídas à campanha mesmo que a pessoa não tenha aberto a notificação se a venda ocorreu em um intervalo de tempo muito próximo ao recebimento da notificação.

Nesses casos, consideramos como se tivesse havido abertura na notificação, adicionando `+1` a `qtd_cliques`.
